<div class="login-page">
  <main class="login-main">
    <div class="login-wrap">
      <div class="login-hero">
        <div class="login-mascot">
          <img src="assets/images/walley-bot.png" alt="Walley" />
        </div>
        <p class="login-tagline">{{ 'LOGIN.ENT_TAGLINE' | translate }}</p>
      </div>

      <div class="login-card glass-card" appInViewport>
        <form [formGroup]="loginForm" (submit)="$event.preventDefault()" class="login-form">
          <div class="login-field mt-2">
            <label class="login-label" for="email">{{ 'LOGIN.EMAIL_CORP' | translate }}</label>
            <div class="login-input-wrap">
              <i class="bi bi-envelope login-input-icon" aria-hidden="true"></i>
              <input
                type="email"
                id="email"
                formControlName="email"
                class="login-input"
                [placeholder]="'LOGIN.PLACEHOLDER_EMAIL' | translate"
                [class.login-input--invalid]="loginForm.get('email')?.invalid && (loginForm.get('email')?.touched || submitted)"
                autocomplete="username"
              />
            </div>
          </div>

          <div class="login-field mt-2">
            <label class="login-label" for="password">{{ 'LOGIN.PASSWORD' | translate }}</label>
            <div class="login-input-wrap">
              <i class="bi bi-lock login-input-icon" aria-hidden="true"></i>
              <input
                [type]="type"
                id="password"
                formControlName="password"
                class="login-input login-input--pwd"
                [class.login-input--invalid]="loginForm.get('password')?.invalid && (loginForm.get('password')?.touched || submitted)"
                autocomplete="current-password"
              />
              <button type="button" class="login-toggle-pwd" (click)="seePassword()" [attr.aria-label]="toggled ? 'Show password' : 'Hide password'">
                <i class="bi" [ngClass]="{ 'bi-eye': !toggled, 'bi-eye-slash': toggled }"></i>
              </button>
            </div>
            <button type="button" class="login-forgot-below" (click)="forgotPassword($event)">
              {{ 'LOGIN.FORGOT_LINK_LINE' | translate }}
            </button>
          </div>

          @if (loginForm.invalid && submitted && invalidCredentials) {
            <div class="login-error">
              <small>{{ 'LOGIN.CHECK_ERRORS' | translate }}</small>
            </div>
          }

          <button type="button" class="login-submit" (click)="login()">
            <span>{{ 'LOGIN.BTN_ACCESS' | translate }}</span>
            <i class="bi bi-arrow-right" aria-hidden="true"></i>
          </button>
        </form>
      </div>

      <div class="login-trust">
        <i class="bi bi-shield-check" aria-hidden="true"></i>
        <p>Walley - ERP</p>
      </div>
    </div>
  </main>
</div>
